import React from 'react';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Destination } from '@marageti/z4-sdk/lib/travel';
import { useFetchImmutable, useApiClient } from '@marageti/z4-lib';
import FinalPageView from './final-page-view';

const FinalPageContainer = ({
  subtitle,
  onSaveForLater,
  onSubmitReview,
  formValues,
  error,
}: {
  subtitle: React.ReactNode,
  onSaveForLater: (data: any) => any,
  onSubmitReview: (data: any) => any
  formValues: any,
  error: ApiError | null
}) => {
  const apiClient = useApiClient();
  const {
    data: destinationsList,
  } = useFetchImmutable<Destination[]>(apiClient.destinationsClient.getDestinations, [{ params: { all: true, served: true } }], true);

  return (
    <FinalPageView
      subtitle={subtitle}
      destinationsList={destinationsList}
      onSaveForLater={onSaveForLater}
      onSubmitReview={onSubmitReview}
      formValues={formValues}
      error={error}
    />
  );
};

export default FinalPageContainer;
